import { modTypes } from "@blings/blings-player";
import { TRIM_EXTEND_TYPE } from "../helpers/modTypeConsts";

export const SearchIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9.80589"
        cy="9.80541"
        r="7.49047"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0156 15.4043L17.9523 18.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BinIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 4.5H3.75H15.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72064 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5M14.25 4.5V15C14.25 15.3978 14.092 15.7794 13.8107 16.0607C13.5294 16.342 13.1478 16.5 12.75 16.5H5.25C4.85218 16.5 4.47064 16.342 4.18934 16.0607C3.90804 15.7794 3.75 15.3978 3.75 15V4.5H14.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ExperimentPlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke="var(--blings_ai_color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V16"
        stroke="var(--blings_ai_color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12H16"
        stroke="var(--blings_ai_color)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AiIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.667 22.0399C16.8884 22.0432 17.0336 21.8686 17.0547 21.5951C17.1 21.0002 17.1211 20.4004 17.2055 19.8115C17.5957 17.0926 19.3466 15.0654 21.8681 14.4253C22.4226 14.2845 22.9981 14.2339 23.5654 14.1545C23.8105 14.1203 23.9907 13.986 23.9994 13.7777C24.0102 13.5178 23.8687 13.3785 23.6468 13.3144C23.5896 13.2981 23.5284 13.2997 23.4692 13.2894C22.8375 13.1784 22.1883 13.13 21.5773 12.943C19.6905 12.3666 18.3196 11.1387 17.5788 9.18815C17.188 8.15877 17.0413 7.07881 17.0341 5.97384C17.032 5.61059 16.891 5.40722 16.6521 5.40178C16.4076 5.3958 16.2825 5.59048 16.2531 5.95318C16.2006 6.60137 16.1764 7.25826 16.0575 7.89394C15.6822 9.90486 14.6871 11.4644 12.9409 12.4307C11.9545 12.9761 10.8976 13.254 9.78459 13.2937C9.46902 13.3046 9.30376 13.4656 9.31045 13.7369C9.31715 14.0023 9.47365 14.1263 9.78047 14.1556C10.2232 14.198 10.6685 14.2366 11.1056 14.3204C13.674 14.813 15.5504 16.7353 16.0621 19.4341C16.1924 20.122 16.2161 20.8333 16.2763 21.5353C16.3036 21.8561 16.4282 22.0367 16.6675 22.0405L16.667 22.0399ZM8.6896 19.0845C8.68394 18.8289 8.49655 18.6837 8.15266 18.6696C6.44092 18.5989 5.17759 17.4819 4.8373 15.7168C4.77089 15.3737 4.76317 15.017 4.73537 14.6662C4.71169 14.372 4.56549 14.1844 4.34566 14.1833C4.11812 14.1823 3.97294 14.3601 3.95595 14.657C3.94463 14.856 3.93227 15.0545 3.91837 15.2535C3.80254 16.9409 2.78426 18.1959 1.22285 18.5592C0.956693 18.6212 0.681787 18.6402 0.409969 18.6734C0.144329 18.706 -0.00599447 18.8583 0.00018321 19.0981C0.00636088 19.3308 0.146388 19.4673 0.405336 19.4929C0.550511 19.507 0.695686 19.52 0.840862 19.5358C2.28438 19.6941 3.39482 20.6642 3.76959 22.1443C3.88131 22.5859 3.9055 23.0535 3.95287 23.5109C3.98581 23.829 4.12893 24.0079 4.38736 23.9997C4.59277 23.9938 4.68235 23.8507 4.69625 23.5277C4.70603 23.3015 4.71632 23.0748 4.74412 22.8507C4.90474 21.5571 5.45713 20.5385 6.60154 19.9485C7.10863 19.687 7.64763 19.5543 8.21186 19.5331C8.51199 19.5217 8.69475 19.346 8.68857 19.0845H8.6896ZM12.1074 4.91074C12.111 4.67964 11.9699 4.52303 11.7208 4.48986C11.5082 4.46158 11.2919 4.45832 11.0824 4.4159C9.74958 4.14347 8.7802 3.39196 8.37608 1.98573C8.23348 1.49034 8.21392 0.954717 8.1506 0.435404C8.11816 0.166231 7.99924 0.00907704 7.78097 0.000376496C7.55342 -0.00886783 7.39743 0.152636 7.37581 0.428334C7.36552 0.563737 7.37015 0.700226 7.36449 0.836172C7.28057 2.71005 6.26846 3.99991 4.55828 4.39524C4.29212 4.45669 4.01413 4.46049 3.74385 4.50563C3.54102 4.53934 3.41592 4.67801 3.42364 4.89769C3.43137 5.12173 3.54771 5.27073 3.77114 5.29738C3.92455 5.31586 4.07951 5.31913 4.23241 5.34251C5.62187 5.55404 6.67207 6.25715 7.12459 7.71504C7.28469 8.23055 7.30322 8.79662 7.37169 9.3415C7.40722 9.62698 7.54415 9.80262 7.77994 9.8048C7.99049 9.80643 8.10941 9.65363 8.12949 9.3589C8.14957 9.07015 8.15265 8.77814 8.19538 8.49319C8.39873 7.137 9.05974 6.13317 10.2973 5.64431C10.7308 5.47302 11.2111 5.42571 11.6739 5.34686C11.9427 5.30118 12.1043 5.16795 12.1079 4.91129L12.1074 4.91074Z"
        fill="var(--blings_ai_color)"
      />
    </svg>
  );
};

export const ThreeDotsHorizontal = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9.5C3 9.91421 3.33579 10.25 3.75 10.25C4.16421 10.25 4.5 9.91421 4.5 9.5C4.5 9.08579 4.16421 8.75 3.75 8.75C3.33579 8.75 3 9.08579 3 9.5Z"
        stroke="#BEBEBE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 9.5C8.25 9.91421 8.58579 10.25 9 10.25C9.41421 10.25 9.75 9.91421 9.75 9.5C9.75 9.08579 9.41421 8.75 9 8.75C8.58579 8.75 8.25 9.08579 8.25 9.5Z"
        stroke="#BEBEBE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 9.5C13.5 9.91421 13.8358 10.25 14.25 10.25C14.6642 10.25 15 9.91421 15 9.5C15 9.08579 14.6642 8.75 14.25 8.75C13.8358 8.75 13.5 9.08579 13.5 9.5Z"
        stroke="#BEBEBE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThreeDotsDraggable = ({ className }: { className: string }) => {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle
        cx="2.23635"
        cy="2.21392"
        r="1.605"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <circle
        cx="6.44631"
        cy="2.21392"
        r="1.605"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <circle
        cx="2.23635"
        cy="7.42391"
        r="1.605"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <circle
        cx="6.44631"
        cy="7.42391"
        r="1.605"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <circle
        cx="2.23635"
        cy="12.6339"
        r="1.605"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <circle
        cx="6.44631"
        cy="12.6339"
        r="1.605"
        fill="currentColor"
        fillOpacity="0.3"
      />
    </svg>
  );
};

export const PlusIconNew = () => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 44.5C35.0457 44.5 44 35.5457 44 24.5C44 13.4543 35.0457 4.49999 24 4.49999C12.9543 4.49999 4 13.4543 4 24.5C4 35.5457 12.9543 44.5 24 44.5Z"
        stroke="#BEBEBE"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 16.5V32.5"
        stroke="#BEBEBE"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 24.5H32"
        stroke="#BEBEBE"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConnectorIcon = ({ type }: { type: modTypes | string }) => {
  switch (type) {
    case modTypes.text:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 4.5C3 3.67157 3.67157 3 4.5 3H6.25C6.66421 3 7 2.66421 7 2.25C7 1.83579 6.66421 1.5 6.25 1.5H4.5C2.84315 1.5 1.5 2.84315 1.5 4.5V6.25C1.5 6.66421 1.83579 7 2.25 7C2.66421 7 3 6.66421 3 6.25V4.5ZM9.75 1.5C9.33579 1.5 9 1.83579 9 2.25C9 2.66421 9.33579 3 9.75 3H11.5C12.3284 3 13 3.67157 13 4.5V6.25C13 6.66421 13.3358 7 13.75 7C14.1642 7 14.5 6.66421 14.5 6.25V4.5C14.5 2.84315 13.1569 1.5 11.5 1.5H9.75ZM3 9.75C3 9.33579 2.66421 9 2.25 9C1.83579 9 1.5 9.33579 1.5 9.75V11.5C1.5 13.1569 2.84315 14.5 4.5 14.5H6.25C6.66421 14.5 7 14.1642 7 13.75C7 13.3358 6.66421 13 6.25 13H4.5C3.67157 13 3 12.3284 3 11.5V9.75ZM14.5 9.75C14.5 9.33579 14.1642 9 13.75 9C13.3358 9 13 9.33579 13 9.75V11.5C13 12.3284 12.3284 13 11.5 13H9.75C9.33579 13 9 13.3358 9 13.75C9 14.1642 9.33579 14.5 9.75 14.5H11.5C13.1569 14.5 14.5 13.1569 14.5 11.5V9.75ZM5.7522 5.00226C5.33798 5.00226 5.0022 5.33804 5.0022 5.75226C5.0022 6.16647 5.33798 6.50226 5.7522 6.50226H7.25183L7.25 10.2519C7.2498 10.6661 7.58542 11.0021 7.99963 11.0023C8.41385 11.0025 8.7498 10.6668 8.75 10.2526L8.75183 6.50226H10.2522C10.6664 6.50226 11.0022 6.16647 11.0022 5.75226C11.0022 5.33804 10.6664 5.00226 10.2522 5.00226H8.0022H5.7522Z"
            fill="#65A9F3"
          />
        </svg>
      );
    case modTypes.asset:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5 3H4.50005C3.67162 3 3.00005 3.67157 3.00005 4.5V9.52717L3.96161 8.82786C4.58293 8.37599 5.4263 8.38219 6.04091 8.84314L6.96874 9.53902L9.33653 7.50948C10.0105 6.93181 11.0102 6.95021 11.6624 7.55228L13 8.78701V4.5C13 3.67157 12.3285 3 11.5 3ZM14.5 10.4978V4.5C14.5 2.84315 13.1569 1.5 11.5 1.5H4.50005C2.8432 1.5 1.50005 2.84315 1.50005 4.5V10.9917C1.49998 10.9976 1.49998 11.0036 1.50005 11.0095V11.5C1.50005 13.1569 2.8432 14.5 4.50005 14.5H11.5C13.1569 14.5 14.5 13.1569 14.5 11.5V10.5026V10.4978ZM13 10.8284L10.645 8.65448C10.5518 8.56847 10.409 8.56584 10.3127 8.64837L7.48814 11.0694L7.03135 11.461L6.55005 11.1L5.14091 10.0431C5.05311 9.97729 4.93262 9.97641 4.84386 10.041L3.00005 11.3819V11.5C3.00005 12.3284 3.67162 13 4.50005 13H11.5C12.3285 13 13 12.3284 13 11.5V10.8284ZM7.50004 6C7.50004 6.82843 6.82847 7.5 6.00005 7.5C5.17162 7.5 4.50005 6.82843 4.50005 6C4.50005 5.17157 5.17162 4.5 6.00005 4.5C6.82847 4.5 7.50004 5.17157 7.50004 6Z"
            fill="#F3956A"
          />
        </svg>
      );
    case modTypes.themeColor:
    case modTypes.color:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0121 10V10C12.4432 10.0035 12.7763 9.84944 13.0139 9.58863C13.2577 9.32099 13.5 8.82745 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C8.12714 13.5 8.23656 13.4966 8.33019 13.4911C8.28505 13.2768 8.222 12.947 8.22365 12.6003C8.22566 12.1775 8.32219 11.6251 8.71896 11.1201C9.10542 10.6283 9.63893 10.3576 10.1673 10.2075C10.6894 10.0592 11.3034 10 12 10H12.0121ZM8.42908 14.0099L8.42896 14.0049C8.42913 14.0084 8.42912 14.01 8.42908 14.0099ZM12 11.5C13.6607 11.5134 15 10.25 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C10.1907 15 10.0114 14.1705 9.8274 13.3191C9.6334 12.4217 9.43417 11.5 12 11.5ZM9 5C9 5.55228 8.55228 6 8 6C7.44772 6 7 5.55228 7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5ZM11 7.75C11.5523 7.75 12 7.30228 12 6.75C12 6.19772 11.5523 5.75 11 5.75C10.4477 5.75 10 6.19772 10 6.75C10 7.30228 10.4477 7.75 11 7.75ZM6.25 6.75C6.25 7.30228 5.80228 7.75 5.25 7.75C4.69772 7.75 4.25 7.30228 4.25 6.75C4.25 6.19772 4.69772 5.75 5.25 5.75C5.80228 5.75 6.25 6.19772 6.25 6.75ZM5.75 11C6.30228 11 6.75 10.5523 6.75 10C6.75 9.44771 6.30228 9 5.75 9C5.19772 9 4.75 9.44771 4.75 10C4.75 10.5523 5.19772 11 5.75 11Z"
            fill="#F3EA62"
          />
        </svg>
      );
    case modTypes.interactiveOpen:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.46967 6.53033C3.76256 6.23744 4.23743 6.23744 4.53033 6.53033C4.82322 6.82323 4.82322 7.2981 4.53033 7.59099L3.8033 8.31802C3.28896 8.83236 3 9.52997 3 10.2574C3 11.7721 4.22792 13 5.74264 13C6.47004 13 7.16764 12.711 7.68198 12.1967L8.409 11.4697C8.70189 11.1768 9.17677 11.1768 9.46966 11.4697C9.76255 11.7626 9.76255 12.2374 9.46966 12.5303L8.74264 13.2574C7.94699 14.053 6.86786 14.5 5.74264 14.5C3.3995 14.5 1.5 12.6005 1.5 10.2574C1.5 9.13214 1.94699 8.05301 2.74264 7.25736L3.46967 6.53033ZM11.4697 8.40901C11.1768 8.7019 11.1768 9.17678 11.4697 9.46967C11.7626 9.76256 12.2374 9.76256 12.5303 9.46967L13.2574 8.74264C14.053 7.94699 14.5 6.86786 14.5 5.74264C14.5 3.3995 12.6005 1.5 10.2574 1.5C9.13214 1.5 8.05301 1.94699 7.25736 2.74264L6.53033 3.46967C6.23744 3.76256 6.23744 4.23744 6.53033 4.53033C6.82322 4.82322 7.2981 4.82322 7.59099 4.53033L8.31802 3.8033C8.83236 3.28896 9.52996 3 10.2574 3C11.7721 3 13 4.22792 13 5.74264C13 6.47003 12.711 7.16764 12.1967 7.68198L11.4697 8.40901ZM10.5303 6.53033C10.8232 6.23744 10.8232 5.76256 10.5303 5.46967C10.2374 5.17678 9.76256 5.17678 9.46967 5.46967L5.46967 9.46967C5.17678 9.76256 5.17678 10.2374 5.46967 10.5303C5.76256 10.8232 6.23744 10.8232 6.53033 10.5303L10.5303 6.53033Z"
            fill="#AB7AE0"
          />
        </svg>
      );
    case modTypes.interactiveLocation:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M11 19C11 19 17 13.75 17 8.75C17 5.43629 14.3137 2.75 11 2.75C7.68629 2.75 5 5.43629 5 8.75C5 13.75 11 19 11 19Z"
            stroke="#8fd460"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="11"
            cy="8.75"
            r="2.25"
            stroke="#8fd460"
            strokeWidth="1.5"
          />
        </svg>
      );
    case modTypes.interactiveCalendar:
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect
            x="3.5"
            y="5"
            width="15"
            height="13.5"
            rx="2"
            stroke="#8fd460"
            strokeWidth="1.5"
          />
          <path
            d="M3.5 9H18.5M7 3.5V6.5M15 3.5V6.5"
            stroke="#8fd460"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M7 12H9M13 12H15M7 15H9M13 15H15"
            stroke="#8fd460"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );
    case modTypes.interactiveGoto:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.46967 10.9697C3.17678 11.2626 3.17678 11.7374 3.46967 12.0303C3.76256 12.3232 4.23744 12.3232 4.53033 12.0303L8.03033 8.53033C8.32322 8.23744 8.32322 7.76256 8.03033 7.46967L4.53033 3.96967C4.23744 3.67678 3.76256 3.67678 3.46967 3.96967C3.17678 4.26256 3.17678 4.73744 3.46967 5.03033L6.43934 8L3.46967 10.9697ZM8.46967 10.9697C8.17678 11.2626 8.17678 11.7374 8.46967 12.0303C8.76256 12.3232 9.23744 12.3232 9.53033 12.0303L13.0303 8.53033C13.3232 8.23744 13.3232 7.76256 13.0303 7.46967L9.53033 3.96967C9.23744 3.67678 8.76256 3.67678 8.46967 3.96967C8.17678 4.26256 8.17678 4.73744 8.46967 5.03033L11.4393 8L8.46967 10.9697Z"
            fill="#AB7AE0"
          />
        </svg>
      );
    case modTypes.interactiveConcat:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.31239 4.90898C5.09184 5.26379 4.69851 5.5 4.25 5.5C3.80149 5.5 3.40816 5.26379 3.18761 4.90898C3.07111 4.72155 3.00282 4.50103 3.00009 4.26475C3.00003 4.25984 3 4.25492 3 4.25C3 3.60279 3.49188 3.07047 4.1222 3.00645C4.16422 3.00219 4.20685 3 4.25 3C4.94036 3 5.5 3.55964 5.5 4.25C5.5 4.49185 5.43132 4.71766 5.31239 4.90898ZM3.18761 11.091C3.06868 11.2823 3 11.5081 3 11.75C3 12.4404 3.55964 13 4.25 13C4.25985 13 4.26967 12.9999 4.27946 12.9997C4.50971 12.9943 4.72513 12.9265 4.90898 12.8124C5.26379 12.5918 5.5 12.1985 5.5 11.75C5.5 11.0596 4.94036 10.5 4.25 10.5C3.80149 10.5 3.40816 10.7362 3.18761 11.091ZM5 9.10352V6.89648C6.15425 6.57002 7 5.50878 7 4.25C7 2.73122 5.76878 1.5 4.25 1.5C2.73122 1.5 1.5 2.73122 1.5 4.25C1.5 5.48401 2.3128 6.52818 3.43223 6.87637C3.4547 6.88335 3.47729 6.89006 3.5 6.89648V9.10352C2.34575 9.42998 1.5 10.4912 1.5 11.75C1.5 13.1739 2.58212 14.345 3.96883 14.4858C4.06128 14.4952 4.15508 14.5 4.25 14.5C5.48401 14.5 6.52818 13.6872 6.87637 12.5678C6.88335 12.5453 6.89006 12.5227 6.89648 12.5H9.5C11.1504 12.5 12.4895 11.1673 12.4999 9.5194C12.5 9.51294 12.5 9.50647 12.5 9.5V6.89648C13.6543 6.57002 14.5 5.50878 14.5 4.25C14.5 2.73122 13.2688 1.5 11.75 1.5C10.2312 1.5 9 2.73122 9 4.25C9 5.48401 9.8128 6.52818 10.9322 6.87636C10.9547 6.88335 10.9773 6.89006 11 6.89648V9.5C11 10.3284 10.3284 11 9.5 11H6.89648C6.64388 10.1069 5.95134 9.39845 5.06777 9.12363C5.0453 9.11665 5.02271 9.10994 5 9.10352ZM12.8124 4.90898C12.9313 4.71766 13 4.49185 13 4.25C13 3.55964 12.4404 3 11.75 3C11.0596 3 10.5 3.55964 10.5 4.25C10.5 4.49185 10.5687 4.71766 10.6876 4.90898C10.9082 5.26379 11.3015 5.5 11.75 5.5C12.1985 5.5 12.5918 5.26379 12.8124 4.90898Z"
            fill="#AB7AE0"
          />
        </svg>
      );
    case modTypes.interactiveJSExpression:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.21967 11.2197C0.926777 11.5126 0.926777 11.9874 1.21967 12.2803C1.51256 12.5732 1.98744 12.5732 2.28033 12.2803L6.03033 8.53033C6.32322 8.23744 6.32322 7.76256 6.03033 7.46967L2.28033 3.71967C1.98744 3.42678 1.51256 3.42678 1.21967 3.71967C0.926777 4.01256 0.926777 4.48744 1.21967 4.78033L4.43934 8L1.21967 11.2197ZM14.25 12.5C14.6642 12.5 15 12.1642 15 11.75C15 11.3358 14.6642 11 14.25 11H7.75C7.33579 11 7 11.3358 7 11.75C7 12.1642 7.33579 12.5 7.75 12.5H14.25Z"
            fill="#AB7AE0"
          />
        </svg>
      );
    case modTypes.embedElement:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 2C3.34315 2 2 3.34315 2 5V11C2 12.6569 3.34315 14 5 14H11C12.6569 14 14 12.6569 14 11V5C14 3.34315 12.6569 2 11 2H5ZM5 3.5H11C11.8284 3.5 12.5 4.17157 12.5 5V11C12.5 11.8284 11.8284 12.5 11 12.5H5C4.17157 12.5 3.5 11.8284 3.5 11V5C3.5 4.17157 4.17157 3.5 5 3.5ZM7 6.25C6.58579 6.25 6.25 6.58579 6.25 7V9C6.25 9.41421 6.58579 9.75 7 9.75H9C9.41421 9.75 9.75 9.41421 9.75 9V7C9.75 6.58579 9.41421 6.25 9 6.25H7ZM7.75 7.75H8.25V8.25H7.75V7.75Z"
            fill="#58D1C9"
          />
        </svg>
      );
    case modTypes.interactiveInput:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 2.25C10 1.83579 10.3358 1.5 10.75 1.5C11.3263 1.5 11.8519 1.71664 12.25 2.07292C12.6481 1.71664 13.1737 1.5 13.75 1.5C14.1642 1.5 14.5 1.83579 14.5 2.25C14.5 2.66421 14.1642 3 13.75 3C13.3358 3 13 3.33579 13 3.75V12.5C13 12.9142 13.3358 13.25 13.75 13.25C14.1642 13.25 14.5 13.5858 14.5 14C14.5 14.4142 14.1642 14.75 13.75 14.75C13.1737 14.75 12.6481 14.5334 12.25 14.1771C11.8519 14.5334 11.3263 14.75 10.75 14.75C10.3358 14.75 10 14.4142 10 14C10 13.5858 10.3358 13.25 10.75 13.25C11.1642 13.25 11.5 12.9142 11.5 12.5V3.75C11.5 3.33579 11.1642 3 10.75 3C10.3358 3 10 2.66421 10 2.25ZM5.74996 3C5.13234 3 4.58186 3.38947 4.37631 3.97188L1.54272 12.0004C1.40486 12.391 1.60975 12.8194 2.00035 12.9572C2.39094 13.0951 2.81934 12.8902 2.9572 12.4996L3.83942 10H7.6605L8.54272 12.4996C8.68058 12.8902 9.10898 13.0951 9.49958 12.9572C9.89017 12.8194 10.0951 12.391 9.9572 12.0004L7.12361 3.97188C6.91806 3.38947 6.36757 3 5.74996 3ZM7.13109 8.5L5.74996 4.5868L4.36883 8.5L7.13109 8.5Z"
            fill="#F37FB7"
          />
        </svg>
      );
    case modTypes.interactiveForm:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 8.5H11.1123C10.5645 9.70101 9.35757 10.5 8 10.5C6.64243 10.5 5.43552 9.70101 4.88769 8.5H2.5V11C2.5 11.8284 3.17157 12.5 4 12.5H12C12.8284 12.5 13.5 11.8284 13.5 11V8.5ZM11.2964 3.74275L13.2507 7H10L9.8638 7.54479C9.64999 8.40003 8.88156 9 8 9C7.11844 9 6.35001 8.40003 6.1362 7.54479L6 7H2.74929L4.70363 3.74275C4.794 3.59215 4.95675 3.5 5.13238 3.5H10.8676C11.0433 3.5 11.206 3.59215 11.2964 3.74275ZM15 8.5V7.83095C15 7.28722 14.8522 6.75371 14.5725 6.28746L12.5826 2.97101C12.2212 2.3686 11.5701 2 10.8676 2H5.13238C4.42986 2 3.77884 2.3686 3.41739 2.97101L1.42752 6.28746C1.14777 6.75371 1 7.28722 1 7.83095V8.5V11C1 12.6569 2.34315 14 4 14H12C13.6569 14 15 12.6569 15 11V8.5Z"
            fill="#F37FB7"
          />
        </svg>
      );
    case modTypes.hideLayer:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.78885 5.28262L6.82624 3.26393C7.17338 3.09036 7.55616 3 7.94427 3H8.05573C8.44384 3 8.82662 3.09036 9.17376 3.26393L13.2111 5.28262C13.3882 5.37114 13.5 5.55208 13.5 5.75C13.5 5.94792 13.3882 6.12886 13.2111 6.21738L9.17376 8.23607C8.82662 8.40964 8.44384 8.5 8.05573 8.5H7.94427C7.55616 8.5 7.17338 8.40964 6.82624 8.23607L2.78885 6.21738C2.61183 6.12886 2.5 5.94792 2.5 5.75C2.5 5.55208 2.61183 5.37114 2.78885 5.28262ZM1 5.75C1 4.98392 1.43283 4.28359 2.11803 3.94098L6.15542 1.92229C6.71084 1.64458 7.32329 1.5 7.94427 1.5H8.05573C8.67671 1.5 9.28916 1.64458 9.84458 1.92229L13.882 3.94098C14.5672 4.28359 15 4.98392 15 5.75C15 6.51608 14.5672 7.21641 13.882 7.55902L13.0001 7.99995L13.882 8.44089C14.5672 8.78349 15 9.48382 15 10.2499C15 11.016 14.5672 11.7163 13.882 12.0589L9.84458 14.0776C9.28916 14.3553 8.67671 14.4999 8.05573 14.4999H7.94427C7.32329 14.4999 6.71084 14.3553 6.15542 14.0776L2.11803 12.0589C1.43283 11.7163 1 11.016 1 10.2499C1 9.48382 1.43283 8.78349 2.11803 8.44089L2.99991 7.99995L2.11803 7.55902C1.43283 7.21641 1 6.51608 1 5.75ZM4.67696 8.83848L2.78885 9.78253C2.61183 9.87104 2.5 10.052 2.5 10.2499C2.5 10.4478 2.61183 10.6288 2.78885 10.7173L6.82624 12.736C7.17338 12.9095 7.55616 12.9999 7.94427 12.9999H8.05573C8.44384 12.9999 8.82662 12.9095 9.17376 12.736L13.2111 10.7173C13.3882 10.6288 13.5 10.4478 13.5 10.2499C13.5 10.052 13.3882 9.87104 13.2111 9.78253L11.323 8.83848L9.84458 9.57771C9.28916 9.85542 8.67671 10 8.05573 10H7.94427C7.32329 10 6.71084 9.85542 6.15542 9.57771L4.67696 8.83848Z"
            fill="#8FD460"
          />
        </svg>
      );
    case modTypes.countdown:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.25 0C5.83579 0 5.5 0.335786 5.5 0.75C5.5 1.16421 5.83579 1.5 6.25 1.5H9.75C10.1642 1.5 10.5 1.16421 10.5 0.75C10.5 0.335786 10.1642 0 9.75 0H6.25ZM13 9C13 11.7614 10.7614 14 8 14C5.23858 14 3 11.7614 3 9C3 6.23858 5.23858 4 8 4C10.7614 4 13 6.23858 13 9ZM14.5 9C14.5 12.5899 11.5899 15.5 8 15.5C4.41015 15.5 1.5 12.5899 1.5 9C1.5 5.41015 4.41015 2.5 8 2.5C11.5899 2.5 14.5 5.41015 14.5 9ZM12.2197 1.71967C12.5126 1.42678 12.9874 1.42678 13.2803 1.71967L14.7803 3.21967C15.0732 3.51256 15.0732 3.98744 14.7803 4.28033C14.4874 4.57322 14.0126 4.57322 13.7197 4.28033L12.2197 2.78033C11.9268 2.48744 11.9268 2.01256 12.2197 1.71967ZM8.75 6C8.75 5.58579 8.41421 5.25 8 5.25C7.58579 5.25 7.25 5.58579 7.25 6V9C7.25 9.23607 7.36115 9.45836 7.55 9.6L8.88333 10.6C9.2147 10.8485 9.6848 10.7814 9.93333 10.45C10.1819 10.1186 10.1147 9.64853 9.78333 9.4L8.75 8.625V6Z"
            fill="#8FD460"
          />
        </svg>
      );
    case modTypes.transitionTiming:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.28033 4.78033C9.57322 4.48744 9.57322 4.01256 9.28033 3.71967L6.78033 1.21967C6.48744 0.926777 6.01256 0.926777 5.71967 1.21967C5.42678 1.51256 5.42678 1.98744 5.71967 2.28033L6.93934 3.5L1.75 3.5C1.33579 3.5 1 3.83579 1 4.25C1 4.66421 1.33579 5 1.75 5L6.93934 5L5.71967 6.21967C5.42678 6.51256 5.42678 6.98744 5.71967 7.28033C6.01256 7.57322 6.48744 7.57322 6.78033 7.28033L9.28033 4.78033ZM9.21967 8.71967L6.71967 11.2197C6.42678 11.5126 6.42678 11.9874 6.71967 12.2803L9.21967 14.7803C9.51256 15.0732 9.98744 15.0732 10.2803 14.7803C10.5732 14.4874 10.5732 14.0126 10.2803 13.7197L9.06066 12.5H14.25C14.6642 12.5 15 12.1642 15 11.75C15 11.3358 14.6642 11 14.25 11H9.06066L10.2803 9.78033C10.5732 9.48744 10.5732 9.01256 10.2803 8.71967C9.98744 8.42678 9.51256 8.42678 9.21967 8.71967ZM14 4.25C14 5.2165 13.2165 6 12.25 6C11.2835 6 10.5 5.2165 10.5 4.25C10.5 3.2835 11.2835 2.5 12.25 2.5C13.2165 2.5 14 3.2835 14 4.25ZM3.75 13.5C4.7165 13.5 5.5 12.7165 5.5 11.75C5.5 10.7835 4.7165 10 3.75 10C2.7835 10 2 10.7835 2 11.75C2 12.7165 2.7835 13.5 3.75 13.5Z"
            fill="#8FD460"
          />
        </svg>
      );
    case TRIM_EXTEND_TYPE:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.25 1.25L7.25 14.75C7.25 15.1642 7.58579 15.5 8 15.5C8.41421 15.5 8.75 15.1642 8.75 14.75L8.75 1.25C8.75 0.835786 8.41421 0.5 8 0.5C7.58579 0.5 7.25 0.835786 7.25 1.25ZM2.5 2H6V3.5H2.5C1.94772 3.5 1.5 3.94772 1.5 4.5V6.25C1.5 6.80228 1.94772 7.25 2.5 7.25L5.5 7.25H6V8.75H5.5C4.94772 8.75 4.5 9.19772 4.5 9.75V11.5C4.5 12.0523 4.94772 12.5 5.5 12.5H6V14H5.5C4.11929 14 3 12.8807 3 11.5V9.75C3 9.39445 3.07422 9.05623 3.20802 8.75H2.5C1.11929 8.75 0 7.63071 0 6.25V4.5C0 3.11929 1.11929 2 2.5 2ZM10.5 7.25H10V8.75H10.5H13.5C14.0523 8.75 14.5 9.19772 14.5 9.75V11.5C14.5 12.0523 14.0523 12.5 13.5 12.5H10V14H13.5C14.8807 14 16 12.8807 16 11.5V9.75C16 8.36929 14.8807 7.25 13.5 7.25H12.792C12.9258 6.94377 13 6.60555 13 6.25V4.5C13 3.11929 11.8807 2 10.5 2H10V3.5H10.5C11.0523 3.5 11.5 3.94772 11.5 4.5V6.25C11.5 6.80228 11.0523 7.25 10.5 7.25Z"
            fill="#8FD460"
          />
        </svg>
      );
    case modTypes.custom:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9985 8.49854C10.1701 8.49854 9.49853 9.17011 9.49853 9.99854C9.49853 10.827 10.1701 11.4985 10.9985 11.4985C11.827 11.4985 12.4985 10.827 12.4985 9.99854C12.4985 9.17011 11.827 8.49854 10.9985 8.49854ZM10.2485 7.09305C8.95461 7.42608 7.99853 8.60066 7.99853 9.99854C7.99853 11.3964 8.95461 12.571 10.2485 12.904L10.2485 14.2512C10.2485 14.6654 10.5843 15.0012 10.9985 15.0012C11.4127 15.0012 11.7485 14.6654 11.7485 14.2512L11.7485 12.904C13.0425 12.571 13.9985 11.3964 13.9985 9.99854C13.9985 8.60066 13.0425 7.42608 11.7485 7.09305L11.7485 1.7484C11.7485 1.33419 11.4127 0.998402 10.9985 0.998402C10.5843 0.998402 10.2485 1.33419 10.2485 1.7484L10.2485 7.09305ZM5.74854 14.2512L5.74853 8.90646C7.04246 8.57343 7.99854 7.39886 7.99854 6.00098C7.99854 4.6031 7.04245 3.42852 5.74853 3.09549L5.74853 1.74829C5.74853 1.33408 5.41275 0.998291 4.99853 0.998291C4.58432 0.998291 4.24853 1.33408 4.24853 1.74829L4.24853 3.09549C2.95461 3.42852 1.99853 4.6031 1.99853 6.00098C1.99853 7.39886 2.95461 8.57343 4.24853 8.90646L4.24854 14.2512C4.24854 14.6654 4.58432 15.0012 4.99854 15.0012C5.41275 15.0012 5.74854 14.6654 5.74854 14.2512ZM6.49854 6.00098C6.49854 6.8294 5.82696 7.50098 4.99853 7.50098C4.17011 7.50098 3.49853 6.8294 3.49853 6.00098C3.49853 5.17255 4.17011 4.50098 4.99853 4.50098C5.82696 4.50098 6.49853 5.17255 6.49854 6.00098Z"
            fill="#58D1C9"
          />
        </svg>
      );
    case modTypes.transform:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.46967 1.21967C7.76256 0.926777 8.23744 0.926777 8.53033 1.21967L10.2803 2.96967C10.5732 3.26256 10.5732 3.73744 10.2803 4.03033C9.98744 4.32322 9.51256 4.32322 9.21967 4.03033L8.75 3.56066V12.4393L9.21967 11.9697C9.51256 11.6768 9.98744 11.6768 10.2803 11.9697C10.5732 12.2626 10.5732 12.7374 10.2803 13.0303L8.53033 14.7803C8.23744 15.0732 7.76256 15.0732 7.46967 14.7803L5.71967 13.0303C5.42678 12.7374 5.42678 12.2626 5.71967 11.9697C6.01256 11.6768 6.48744 11.6768 6.78033 11.9697L7.25 12.4393V3.56066L6.78033 4.03033C6.48744 4.32322 6.01256 4.32322 5.71967 4.03033C5.42678 3.73744 5.42678 3.26256 5.71967 2.96967L7.46967 1.21967ZM1.21967 7.46967C0.926777 7.76256 0.926777 8.23744 1.21967 8.53033L2.96967 10.2803C3.26256 10.5732 3.73744 10.5732 4.03033 10.2803C4.32322 9.98744 4.32322 9.51256 4.03033 9.21967L2.81066 8L4.03033 6.78033C4.32322 6.48744 4.32322 6.01256 4.03033 5.71967C3.73744 5.42678 3.26256 5.42678 2.96967 5.71967L1.21967 7.46967ZM14.7803 8.53033L13.0303 10.2803C12.7374 10.5732 12.2626 10.5732 11.9697 10.2803C11.6768 9.98744 11.6768 9.51256 11.9697 9.21967L13.1893 8L11.9697 6.78033C11.6768 6.48744 11.6768 6.01256 11.9697 5.71967C12.2626 5.42678 12.7374 5.42678 13.0303 5.71967L14.7803 7.46967C15.0732 7.76256 15.0732 8.23744 14.7803 8.53033Z"
            fill="#58D1C9"
          />
          <path
            d="M2.5 8L13.5 8"
            stroke="#58D1C9"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case modTypes.onPlayerEvent:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.8355 6L8.59551 3.97331L9.3355 2H5.5C5.20741 2 4.94429 2.17814 4.83563 2.4498L2.51266 8.25722C2.5043 8.27813 2.5 8.30045 2.5 8.32297C2.5 8.42074 2.57926 8.5 2.67703 8.5H5.5H7.64155L6.90969 10.5126L5.82791 13.4875C5.73732 13.7366 5.9218 14 6.18686 14C6.29218 14 6.39282 13.9565 6.465 13.8798L13.4212 6.48891C13.4718 6.4351 13.5 6.36399 13.5 6.29009C13.5 6.12988 13.3701 6 13.2099 6H10H7.8355ZM9.39326 1.84597L9.39321 1.8461L9.39326 1.84597ZM10.5625 3L10.7978 2.37266C11.1375 1.46656 10.4677 0.5 9.5 0.5H5.5C4.59405 0.5 3.77937 1.05156 3.44291 1.89271L1.11995 7.70013C1.04071 7.89822 1 8.10962 1 8.32297C1 9.24917 1.75083 10 2.67703 10H3.9039H5.5L4.95455 11.5L4.41822 12.9749C3.9719 14.2023 4.88085 15.5 6.18686 15.5C6.70577 15.5 7.20165 15.2857 7.5573 14.9079L14.5135 7.51696C14.826 7.1849 15 6.74609 15 6.29009C15 5.30145 14.1985 4.5 13.2099 4.5H11.602H10L10.5625 3Z"
            fill="#58D1C9"
          />
        </svg>
      );
    default:
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="21" height="21" rx="4" fill="var(--my-dynamic-color)" />
          <path
            d="M11.4168 5.91667H7.75016C7.50705 5.91667 7.27389 6.01325 7.10198 6.18516C6.93007 6.35707 6.8335 6.59022 6.8335 6.83334V14.1667C6.8335 14.4098 6.93007 14.6429 7.10198 14.8149C7.27389 14.9868 7.50705 15.0833 7.75016 15.0833H13.2502C13.4933 15.0833 13.7264 14.9868 13.8983 14.8149C14.0703 14.6429 14.1668 14.4098 14.1668 14.1667V8.66667L11.4168 5.91667Z"
            stroke="currentColor"
            strokeWidth="0.92"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.4165 5.91667V8.66667H14.1665"
            stroke="currentColor"
            strokeWidth="0.92"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.125 11.875H11.875"
            stroke="currentColor"
            strokeWidth="0.92"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
};

export const DeleteIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H5H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const VideoIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2976 15.5383C16.3785 17.3704 14.8999 18.9196 12.9953 18.9975C12.8551 19.0034 6.01604 18.9896 6.01604 18.9896C4.12069 19.1335 2.46188 17.7715 2.31238 15.9463C2.30112 15.8103 2.30419 8.47219 2.30419 8.47219C2.22023 6.63815 3.69678 5.08499 5.60236 5.00418C5.74469 4.99728 12.5745 5.01009 12.5745 5.01009C14.4791 4.86818 16.143 6.24001 16.2904 8.07405C16.3007 8.2061 16.2976 15.5383 16.2976 15.5383Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3008 9.97984L19.5938 7.28484C20.4098 6.61684 21.6338 7.19884 21.6328 8.25184L21.6208 15.6008C21.6198 16.6538 20.3948 17.2308 19.5808 16.5628L16.3008 13.8678"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DuplicateIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EyeIconInvisible = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_180201_21206)">
        <path
          d="M9.9 4.24002C10.5883 4.0789 11.2931 3.99836 12 4.00003C19 4.00003 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.572 9.14351 13.1984C8.99262 12.8249 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2219 9.18488 10.8539C9.34884 10.4859 9.58525 10.1547 9.88 9.88003M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06003L17.94 17.94Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 1L23 23"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_180201_21206">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EditPenIcon = ({ size }: { size?: number } = {}) => {
  return (
    <svg
      width={size || 16}
      height={size || 16}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2.99981C17.2626 2.73717 17.5744 2.52883 17.9176 2.38669C18.2608 2.24455 18.6286 2.17139 19 2.17139C19.3714 2.17139 19.7392 2.24455 20.0824 2.38669C20.4256 2.52883 20.7374 2.73717 21 2.99981C21.2626 3.26246 21.471 3.57426 21.6131 3.91742C21.7553 4.26058 21.8284 4.62838 21.8284 4.99981C21.8284 5.37125 21.7553 5.73905 21.6131 6.08221C21.471 6.42537 21.2626 6.73717 21 6.99981L7.5 20.4998L2 21.9998L3.5 16.4998L17 2.99981Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ExpressionIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2184 3.2156C10.3374 2.81886 10.1123 2.40074 9.71551 2.28172C9.31877 2.1627 8.90065 2.38784 8.78163 2.78458L5.78163 12.7846C5.66261 13.1813 5.88774 13.5994 6.28449 13.7185C6.68123 13.8375 7.09935 13.6123 7.21837 13.2156L10.2184 3.2156ZM4.53033 4.96952C4.82322 5.26241 4.82322 5.73728 4.53033 6.03018L2.56066 7.99985L4.53033 9.96952C4.82322 10.2624 4.82322 10.7373 4.53033 11.0302C4.23744 11.3231 3.76256 11.3231 3.46967 11.0302L0.96967 8.53018C0.829018 8.38952 0.75 8.19876 0.75 7.99985C0.75 7.80093 0.829018 7.61017 0.96967 7.46952L3.46967 4.96952C3.76256 4.67662 4.23744 4.67662 4.53033 4.96952ZM11.4697 11.0302C11.1768 10.7373 11.1768 10.2624 11.4697 9.96952L13.4393 7.99985L11.4697 6.03018C11.1768 5.73728 11.1768 5.26241 11.4697 4.96952C11.7626 4.67662 12.2374 4.67662 12.5303 4.96952L15.0303 7.46952C15.171 7.61017 15.25 7.80093 15.25 7.99985C15.25 8.19876 15.171 8.38952 15.0303 8.53018L12.5303 11.0302C12.2374 11.3231 11.7626 11.3231 11.4697 11.0302Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DataKeyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="8"
      cy="4"
      rx="5"
      ry="2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 4V8C3 9.10457 5.23858 10 8 10C10.7614 10 13 9.10457 13 8V4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 8V12C3 13.1046 5.23858 14 8 14C10.7614 14 13 13.1046 13 12V8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaperIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16666 1.33331H4.5C4.14638 1.33331 3.80724 1.47379 3.55719 1.72384C3.30714 1.97389 3.16666 2.31302 3.16666 2.66665V13.3333C3.16666 13.6869 3.30714 14.0261 3.55719 14.2761C3.80724 14.5262 4.14638 14.6666 4.5 14.6666H12.5C12.8536 14.6666 13.1928 14.5262 13.4428 14.2761C13.6929 14.0261 13.8333 13.6869 13.8333 13.3333V5.99998L9.16666 1.33331Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16666 1.33331V5.99998H13.8333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LiveControlIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8"
      cy="9"
      r="1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 11.5C4.67157 10.6716 4.17157 9.5 4.17157 9C4.17157 6.79086 5.79086 5 8 5C10.2091 5 11.8284 6.79086 11.8284 9C11.8284 9.5 11.3284 10.6716 10.5 11.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 13.5C2.11929 12.1193 1.5 10.5 1.5 9C1.5 5.41015 4.41015 2.5 8 2.5C11.5899 2.5 14.5 5.41015 14.5 9C14.5 10.5 13.8807 12.1193 12.5 13.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InputNameIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73478 2 2V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V4L7 1Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.5H4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6.5H4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 4.5H4.5H4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 1V4H10"
      stroke="#BEBEBE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ArrowRightIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 8C1.25 7.58579 1.58579 7.25 2 7.25L12.1893 7.25L9.46967 4.53033C9.17678 4.23744 9.17678 3.76256 9.46967 3.46967C9.76256 3.17678 10.2374 3.17678 10.5303 3.46967L14.5303 7.46967C14.8232 7.76256 14.8232 8.23744 14.5303 8.53033L10.5303 12.5303C10.2374 12.8232 9.76256 12.8232 9.46967 12.5303C9.17678 12.2374 9.17678 11.7626 9.46967 11.4697L12.1893 8.75L2 8.75C1.58579 8.75 1.25 8.41421 1.25 8Z"
      fill="currentColor"
    />
  </svg>
);
export const TrashIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6H5H21"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DownIcon = () => (
  <div style={{ display: "flex" }}>
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.375 6C1.375 8.554 3.4455 10.625 6 10.625C8.554 10.625 10.625 8.554 10.625 6C10.625 3.446 8.554 1.375 6 1.375C3.4455 1.375 1.375 3.446 1.375 6Z"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.2644 5.27887L5.9999 7.02187L7.7354 5.27887"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export const UpIcon = () => (
  <div style={{ display: "flex" }}>
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10.6249C8.554 10.6249 10.625 8.55441 10.625 5.99991C10.625 3.44591 8.554 1.37491 6 1.37491C3.446 1.37491 1.375 3.44591 1.375 5.99991C1.375 8.55441 3.446 10.6249 6 10.6249Z"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.27885 7.7355L7.02185 6L5.27885 4.2645"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export const QuestionMark = () => (
  <div style={{ display: "flex" }}>
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0.5C2.68661 0.5 0 3.18661 0 6.5C0 9.81339 2.68661 12.5 6 12.5C9.31339 12.5 12 9.81339 12 6.5C12 3.18661 9.31339 0.5 6 0.5ZM6 11.4821C3.24911 11.4821 1.01786 9.25089 1.01786 6.5C1.01786 3.74911 3.24911 1.51786 6 1.51786C8.75089 1.51786 10.9821 3.74911 10.9821 6.5C10.9821 9.25089 8.75089 11.4821 6 11.4821Z"
        fill="#BEBEBE"
      />
      <path
        d="M7.49464 3.88438C7.09285 3.53215 6.5625 3.33929 6 3.33929C5.4375 3.33929 4.90714 3.53349 4.50535 3.88438C4.0875 4.25001 3.85714 4.74153 3.85714 5.26787V5.36965C3.85714 5.42858 3.90535 5.47679 3.96428 5.47679H4.60714C4.66607 5.47679 4.71428 5.42858 4.71428 5.36965V5.26787C4.71428 4.67724 5.29151 4.19644 6 4.19644C6.70848 4.19644 7.28571 4.67724 7.28571 5.26787C7.28571 5.68438 6.99107 6.06608 6.53437 6.24153C6.25044 6.35001 6.00937 6.54019 5.8366 6.78929C5.66116 7.04376 5.57009 7.34912 5.57009 7.65849V7.94644C5.57009 8.00537 5.6183 8.05358 5.67723 8.05358H6.32009C6.37901 8.05358 6.42723 8.00537 6.42723 7.94644V7.64242C6.42792 7.5124 6.46778 7.38561 6.5416 7.27858C6.61542 7.17156 6.71978 7.08926 6.84107 7.04242C7.63125 6.7384 8.14151 6.04197 8.14151 5.26787C8.14285 4.74153 7.9125 4.25001 7.49464 3.88438ZM5.46428 9.44644C5.46428 9.58852 5.52072 9.72478 5.62119 9.82524C5.72166 9.92571 5.85792 9.98215 6 9.98215C6.14208 9.98215 6.27834 9.92571 6.3788 9.82524C6.47927 9.72478 6.53571 9.58852 6.53571 9.44644C6.53571 9.30436 6.47927 9.1681 6.3788 9.06763C6.27834 8.96716 6.14208 8.91072 6 8.91072C5.85792 8.91072 5.72166 8.96716 5.62119 9.06763C5.52072 9.1681 5.46428 9.30436 5.46428 9.44644Z"
        fill="#BEBEBE"
      />
    </svg>
  </div>
);
export const OldValueIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_180233_195730)">
      <path
        d="M5.5 2H2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V10C1 10.2652 1.10536 10.5196 1.29289 10.7071C1.48043 10.8946 1.73478 11 2 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V6.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 1.24999C9.44891 1.05108 9.7187 0.939331 10 0.939331C10.2813 0.939331 10.5511 1.05108 10.75 1.24999C10.9489 1.4489 11.0607 1.71869 11.0607 1.99999C11.0607 2.2813 10.9489 2.55108 10.75 2.74999L6 7.49999L4 7.99999L4.5 5.99999L9.25 1.24999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_180233_195730">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ValueIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V11.5C2.5 12.6046 3.39543 13.5 4.5 13.5H11.5C12.6046 13.5 13.5 12.6046 13.5 11.5V8.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 2.5L6.5 8.5L6 10L7.5 9.5L13.5 3.5L12.5 2.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExposedToPlatformIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 20H2.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 16.1C2.96089 16.296 3.84294 16.7702 4.53638 17.4636C5.22982 18.1571 5.70403 19.0391 5.9 20M2 12.05C4.03079 12.2759 5.92428 13.186 7.36911 14.6309C8.81395 16.0757 9.72414 17.9692 9.95 20M2 8V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarningIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="21" height="21" rx="4" fill="#2c2d33" />
    <path
      d="M9.57343 6.09083L4.98551 13.75C4.89092 13.9138 4.84087 14.0995 4.84034 14.2887C4.83981 14.4779 4.88882 14.6639 4.98249 14.8282C5.07616 14.9925 5.21124 15.1295 5.37427 15.2254C5.5373 15.3214 5.72261 15.3729 5.91176 15.375H15.0876C15.2767 15.3729 15.4621 15.3214 15.6251 15.2254C15.7881 15.1295 15.9232 14.9925 16.0169 14.8282C16.1105 14.6639 16.1595 14.4779 16.159 14.2887C16.1585 14.0995 16.1084 13.9138 16.0138 13.75L11.4259 6.09083C11.3294 5.93164 11.1934 5.80002 11.0312 5.70868C10.8689 5.61733 10.6859 5.56935 10.4997 5.56935C10.3135 5.56935 10.1304 5.61733 9.96819 5.70868C9.80595 5.80002 9.66999 5.93164 9.57343 6.09083V6.09083Z"
      stroke="var(--my-dynamic-color)"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 8.875V11.0417"
      stroke="var(--my-dynamic-color)"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 13.2083H10.5054"
      stroke="var(--my-dynamic-color)"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TimeIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7077 10.0003C17.7077 14.2578 14.2568 17.7087 9.99935 17.7087C5.74185 17.7087 2.29102 14.2578 2.29102 10.0003C2.29102 5.74283 5.74185 2.29199 9.99935 2.29199C14.2568 2.29199 17.7077 5.74283 17.7077 10.0003Z"
      stroke="#BEBEBE"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8585 12.4524L9.7168 10.5782V6.53906"
      stroke="#BEBEBE"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UploadIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 8L12 3L7 8"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V15"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightScrollArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 13.5L11.25 9L6.75 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LeftScrollArrowIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 4.5L7.25 9L11.75 13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ResetSceneIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="8 2.5 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="back-icon"
  >
    <g filter="url(#filter0_d)">
      <rect x="8" y="2.5" width="14" height="14" rx="7" fill="#FFA940" />
      <g clipPath="url(#clip0)">
        <path
          d="M14.3 9.96666L13.1333 8.8L14.3 7.63333"
          stroke="#1F1F1F"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.8666 11.3667V9.73334C16.8666 9.4858 16.7683 9.2484 16.5933 9.07337C16.4182 8.89834 16.1808 8.8 15.9333 8.8H13.1333"
          stroke="#1F1F1F"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="6" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect
          width="5.6"
          height="5.6"
          fill="white"
          transform="translate(12.2 6.7)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const FlowIcon = ({ width = 18, height = 18 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.33909 4.06927L11.5519 4.05762C12.7164 4.0553 13.6603 5.00083 13.6557 6.1645L13.6526 6.9866C13.648 8.14328 12.7086 9.07875 11.5527 9.07875H6.56034C5.40054 9.07875 4.46045 10.0188 4.46045 11.1779V11.9867C4.46045 13.1465 5.40132 14.0874 6.56112 14.0867L15.3139 14.0828"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3133 14.083L13.6458 15.7506"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6458 12.416L15.3133 14.0835"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.32426 4.06887C6.32426 5.0734 5.50993 5.88774 4.50539 5.88774C3.50087 5.88774 2.68652 5.0734 2.68652 4.06887C2.68652 3.06433 3.50087 2.25 4.50539 2.25C5.50993 2.25 6.32426 3.06433 6.32426 4.06887Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LayersIcon = ({ width = 18, height = 18 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    className="layers-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8594 8.18497L13.0933 7.75513L10.2716 9.34777C9.80938 9.60553 9.28738 9.73729 8.77258 9.73729C8.25058 9.73729 7.72858 9.60553 7.26562 9.34777L6.96177 9.17569L4.44465 7.75513L3.67857 8.18497C3.30849 8.38945 3.09033 8.77249 3.09033 9.19585C3.09033 9.62497 3.30849 10.0015 3.67857 10.2132L4.39857 10.6164L7.26562 12.2278C7.72858 12.4855 8.25058 12.618 8.77258 12.618C9.28738 12.618 9.80938 12.4855 10.2716 12.2278L13.1394 10.6164L13.8594 10.2067C14.2295 10.0015 14.4541 9.62497 14.4541 9.19585C14.4541 8.77249 14.2295 8.38945 13.8594 8.18497Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.67857 6.73016L4.44465 7.15928L6.96177 8.57987L7.26562 8.75195C7.72858 9.00971 8.25058 9.14147 8.77258 9.14147C9.28738 9.14147 9.80938 9.00971 10.2716 8.75195L13.0933 7.15928L13.8594 6.73016C14.2295 6.52568 14.4541 6.14264 14.4541 5.71928C14.4541 5.29664 14.2295 4.9136 13.8594 4.7084L10.2716 2.68664C9.34714 2.17184 8.1973 2.17184 7.26562 2.68664L3.67857 4.7084C3.30849 4.9136 3.09033 5.29664 3.09033 5.71928C3.09033 6.14264 3.30849 6.52568 3.67857 6.73016Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8594 11.5199L13.1394 11.1167L10.2716 12.7288C9.80938 12.9865 9.28738 13.119 8.77258 13.119C8.25058 13.119 7.72858 12.9865 7.26562 12.7288L4.39857 11.1167L3.67857 11.5199C3.30849 11.7309 3.09033 12.1081 3.09033 12.5308C3.09033 12.9599 3.30849 13.3365 3.67857 13.5481L7.26562 15.5634C7.72858 15.8205 8.25058 15.9529 8.77258 15.9529C9.28738 15.9529 9.80938 15.8205 10.2716 15.5634L13.8594 13.5481C14.2295 13.3365 14.4541 12.9599 14.4541 12.5308C14.4541 12.1081 14.2295 11.7309 13.8594 11.5199Z"
    />
  </svg>
);
export const ImageIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6622 2.25H6.33348C4.13174 2.25 2.75 3.81121 2.75 6.01952V11.9769C2.75 14.186 4.1259 15.7464 6.33348 15.7464H12.6578C14.8705 15.7464 16.2413 14.186 16.2413 11.9769V6.01952C16.2486 3.81121 14.8734 2.25 12.6622 2.25Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5679 6.66482C8.5679 7.41041 7.96314 8.01517 7.21756 8.01517C6.47197 8.01517 5.86792 7.41041 5.86792 6.66482C5.86792 5.91924 6.47197 5.31445 7.21756 5.31445C7.96314 5.31445 8.56722 5.91851 8.5679 6.66337V6.66482Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.25 11.1743C15.5752 10.4798 14.2767 9.07617 12.865 9.07617C11.4541 9.07617 10.6392 12.1723 9.28153 12.1723C7.92457 12.1723 6.68873 10.7723 5.60392 11.6697C4.76568 12.4699 4.05146 13.3899 3.48242 14.3996"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DragIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.02842 17.3053H8.96444M9.01467 17.5645C8.87066 17.5645 8.75391 17.4477 8.75391 17.3037C8.75391 17.1597 8.87066 17.043 9.01467 17.043C9.15869 17.043 9.27544 17.1597 9.27544 17.3037C9.27544 17.4477 9.15869 17.5645 9.01467 17.5645Z"
      stroke="#595959"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.02842 11.7838H8.96444M9.01467 12.0431C8.87066 12.0431 8.75391 11.9262 8.75391 11.7822C8.75391 11.6382 8.87066 11.5215 9.01467 11.5215C9.15869 11.5215 9.27544 11.6382 9.27544 11.7822C9.27544 11.9262 9.15869 12.0431 9.01467 12.0431Z"
      stroke="#595959"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.27451 6.26229H9.21053M9.26076 6.52156C9.11675 6.52156 9 6.40471 9 6.2607C9 6.11668 9.11675 6 9.26076 6C9.40478 6 9.52153 6.11668 9.52153 6.2607C9.52153 6.40471 9.40478 6.52156 9.26076 6.52156Z"
      stroke="#595959"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.796 17.3053H13.732M13.7823 17.5645C13.6383 17.5645 13.5215 17.4477 13.5215 17.3037C13.5215 17.1597 13.6383 17.043 13.7823 17.043C13.9263 17.043 14.043 17.1597 14.043 17.3037C14.043 17.4477 13.9263 17.5645 13.7823 17.5645Z"
      stroke="#595959"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.796 11.7838H13.732M13.7823 12.0431C13.6383 12.0431 13.5215 11.9262 13.5215 11.7822C13.5215 11.6382 13.6383 11.5215 13.7823 11.5215C13.9263 11.5215 14.043 11.6382 14.043 11.7822C14.043 11.9262 13.9263 12.0431 13.7823 12.0431Z"
      stroke="#595959"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.796 6.26229H13.732M13.7823 6.52156C13.6383 6.52156 13.5215 6.40471 13.5215 6.2607C13.5215 6.11668 13.6383 6 13.7823 6C13.9263 6 14.043 6.11668 14.043 6.2607C14.043 6.40471 13.9263 6.52156 13.7823 6.52156Z"
      stroke="#595959"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DotsMenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4366 17.7891C12.9946 17.7891 13.4474 18.2413 13.4474 18.7998C13.4474 19.3576 12.9952 19.8106 12.4366 19.8106C11.878 19.8106 11.4258 19.3576 11.4258 18.7998C11.4258 18.2413 11.8786 17.7891 12.4366 17.7891Z"
      fill="#BEBEBE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4366 11.7656C12.9946 11.7656 13.4474 12.2179 13.4474 12.7763C13.4474 13.3342 12.9952 13.7872 12.4366 13.7872C11.878 13.7872 11.4258 13.3342 11.4258 12.7763C11.4258 12.2179 11.8786 11.7656 12.4366 11.7656Z"
      fill="#BEBEBE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4366 5.74609C12.9946 5.74609 13.4474 6.19833 13.4474 6.75679C13.4474 7.31467 12.9952 7.76765 12.4366 7.76765C11.878 7.76765 11.4258 7.31467 11.4258 6.75679C11.4258 6.19832 11.8786 5.74609 12.4366 5.74609Z"
      fill="#BEBEBE"
    />
  </svg>
);
export const RightArrowIcon = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.125 8H11.875"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 3.625L11.875 8L7.5 12.375"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L4 12"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 4L12 12"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AddOutlinedIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.74038 6.32471V11.6607"
      stroke="#BEBEBE"
      strokeWidth="1.0925"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4109 8.99298H6.06982"
      stroke="#BEBEBE"
      strokeWidth="1.0925"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1529 1.71631H5.32736C2.94814 1.71631 1.45679 3.40028 1.45679 5.78416V12.2151C1.45679 14.599 2.9412 16.283 5.32736 16.283H12.1529C14.539 16.283 16.0235 14.599 16.0235 12.2151V5.78416C16.0235 3.40028 14.539 1.71631 12.1529 1.71631Z"
      stroke="#BEBEBE"
      strokeWidth="1.0925"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ForkIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.06562 5.1603C2.05405 4.87568 1.3125 3.94631 1.3125 2.84375C1.3125 2.76069 1.31671 2.67862 1.32492 2.59772C1.44815 1.38436 2.47287 0.4375 3.71875 0.4375C5.04768 0.4375 6.125 1.51481 6.125 2.84375C6.125 3.94299 5.38791 4.87008 4.38101 5.15771C4.44464 5.82325 5.00529 6.34375 5.6875 6.34375H7H8.3125C8.99471 6.34375 9.55536 5.82326 9.61898 5.15771C8.61209 4.87008 7.875 3.94299 7.875 2.84375C7.875 1.51481 8.95231 0.4375 10.2812 0.4375C11.6102 0.4375 12.6875 1.51482 12.6875 2.84375C12.6875 2.92681 12.6833 3.00888 12.6751 3.08977C12.5742 4.08268 11.8697 4.89712 10.9344 5.1603C10.8671 6.55011 9.71898 7.65625 8.3125 7.65625H7.65625V8.84057C8.66622 9.12623 9.40625 10.0548 9.40625 11.1562C9.40625 12.4852 8.32893 13.5625 7 13.5625C5.67106 13.5625 4.59375 12.4852 4.59375 11.1562C4.59375 11.0732 4.59796 10.9911 4.60617 10.9102C4.70689 9.91842 5.40994 9.10469 6.34375 8.84057V7.65625H5.6875C4.28102 7.65625 3.1329 6.5501 3.06562 5.1603ZM2.625 2.84375C2.625 2.23969 3.11469 1.75 3.71875 1.75C4.32281 1.75 4.8125 2.23969 4.8125 2.84375C4.8125 3.44781 4.32281 3.9375 3.71875 3.9375C3.15244 3.9375 2.68666 3.50711 2.63065 2.95558C2.62691 2.91881 2.625 2.8815 2.625 2.84375ZM5.90625 11.1562C5.90625 10.5522 6.39594 10.0625 7 10.0625C7.60406 10.0625 8.09375 10.5522 8.09375 11.1562C8.09375 11.7603 7.60406 12.25 7 12.25C6.43369 12.25 5.96791 11.8196 5.9119 11.2681C5.90816 11.2313 5.90625 11.194 5.90625 11.1562ZM9.1875 2.84375C9.1875 2.23969 9.67719 1.75 10.2812 1.75C10.8853 1.75 11.375 2.23969 11.375 2.84375C11.375 3.44781 10.8853 3.9375 10.2812 3.9375C9.67719 3.9375 9.1875 3.44781 9.1875 2.84375Z"
      fill="white"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 15H15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.375 2.62517C12.6734 2.3268 13.078 2.15918 13.5 2.15918C13.7089 2.15918 13.9158 2.20033 14.1088 2.28029C14.3019 2.36024 14.4773 2.47743 14.625 2.62517C14.7727 2.77291 14.8899 2.9483 14.9699 3.14132C15.0498 3.33435 15.091 3.54124 15.091 3.75017C15.091 3.9591 15.0498 4.16599 14.9699 4.35902C14.8899 4.55204 14.7727 4.72743 14.625 4.87517L5.25 14.2502L2.25 15.0002L3 12.0002L12.375 2.62517Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CrownIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7136 7.38895C13.2572 6.94893 14.5285 5.91908 15.5545 5.08767C15.8055 4.88374 16.1757 5.09865 16.1192 5.4171C15.9239 6.52852 15.4526 10.0001 15.1749 12.0778C15.0509 13.0064 14.2595 13.6943 13.323 13.6943H5.42933C4.49282 13.6943 3.70142 13.0064 3.5767 12.0786C3.29904 10.0008 2.82686 6.53009 2.63078 5.41788C2.5743 5.09943 2.94452 4.88453 3.19551 5.08767C4.22144 5.91987 5.49208 6.94893 6.03642 7.38895C6.18152 7.5066 6.38781 7.49013 6.51173 7.34973C7.07411 6.71833 8.52593 5.08611 9.11813 4.42019C9.2562 4.26489 9.4938 4.26489 9.63187 4.42019C10.2232 5.08611 11.6751 6.71833 12.2375 7.34973C12.3622 7.49013 12.5685 7.5066 12.7136 7.38895Z"
      stroke="#BEBEBE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1707 10.5762H8.59131"
      stroke="#BEBEBE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TextIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4.5C3 3.67157 3.67157 3 4.5 3H6.25C6.66421 3 7 2.66421 7 2.25C7 1.83579 6.66421 1.5 6.25 1.5H4.5C2.84315 1.5 1.5 2.84315 1.5 4.5V6.25C1.5 6.66421 1.83579 7 2.25 7C2.66421 7 3 6.66421 3 6.25V4.5ZM9.75 1.5C9.33579 1.5 9 1.83579 9 2.25C9 2.66421 9.33579 3 9.75 3H11.5C12.3284 3 13 3.67157 13 4.5V6.25C13 6.66421 13.3358 7 13.75 7C14.1642 7 14.5 6.66421 14.5 6.25V4.5C14.5 2.84315 13.1569 1.5 11.5 1.5H9.75ZM3 9.75C3 9.33579 2.66421 9 2.25 9C1.83579 9 1.5 9.33579 1.5 9.75V11.5C1.5 13.1569 2.84315 14.5 4.5 14.5H6.25C6.66421 14.5 7 14.1642 7 13.75C7 13.3358 6.66421 13 6.25 13H4.5C3.67157 13 3 12.3284 3 11.5V9.75ZM14.5 9.75C14.5 9.33579 14.1642 9 13.75 9C13.3358 9 13 9.33579 13 9.75V11.5C13 12.3284 12.3284 13 11.5 13H9.75C9.33579 13 9 13.3358 9 13.75C9 14.1642 9.33579 14.5 9.75 14.5H11.5C13.1569 14.5 14.5 13.1569 14.5 11.5V9.75ZM5.7522 5.00226C5.33798 5.00226 5.0022 5.33804 5.0022 5.75226C5.0022 6.16647 5.33798 6.50226 5.7522 6.50226H7.25183L7.25 10.2519C7.2498 10.6661 7.58542 11.0021 7.99963 11.0023C8.41385 11.0025 8.7498 10.6668 8.75 10.2526L8.75183 6.50226H10.2522C10.6664 6.50226 11.0022 6.16647 11.0022 5.75226C11.0022 5.33804 10.6664 5.00226 10.2522 5.00226H8.0022H5.7522Z"
        fill="#65A9F3"
      />
    </svg>
  );
};

export const AssetIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 3H4.50005C3.67162 3 3.00005 3.67157 3.00005 4.5V9.52717L3.96161 8.82786C4.58293 8.37599 5.4263 8.38219 6.04091 8.84314L6.96874 9.53902L9.33653 7.50948C10.0105 6.93181 11.0102 6.95021 11.6624 7.55228L13 8.78701V4.5C13 3.67157 12.3285 3 11.5 3ZM14.5 10.4978V4.5C14.5 2.84315 13.1569 1.5 11.5 1.5H4.50005C2.8432 1.5 1.50005 2.84315 1.50005 4.5V10.9917C1.49998 10.9976 1.49998 11.0036 1.50005 11.0095V11.5C1.50005 13.1569 2.8432 14.5 4.50005 14.5H11.5C13.1569 14.5 14.5 13.1569 14.5 11.5V10.5026V10.4978ZM13 10.8284L10.645 8.65448C10.5518 8.56847 10.409 8.56584 10.3127 8.64837L7.48814 11.0694L7.03135 11.461L6.55005 11.1L5.14091 10.0431C5.05311 9.97729 4.93262 9.97641 4.84386 10.041L3.00005 11.3819V11.5C3.00005 12.3284 3.67162 13 4.50005 13H11.5C12.3285 13 13 12.3284 13 11.5V10.8284ZM7.50004 6C7.50004 6.82843 6.82847 7.5 6.00005 7.5C5.17162 7.5 4.50005 6.82843 4.50005 6C4.50005 5.17157 5.17162 4.5 6.00005 4.5C6.82847 4.5 7.50004 5.17157 7.50004 6Z"
        fill="#F3956A"
      />
    </svg>
  );
};

export const ColorIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0121 10V10C12.4432 10.0035 12.7763 9.84944 13.0139 9.58863C13.2577 9.32099 13.5 8.82745 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C8.12714 13.5 8.23656 13.4966 8.33019 13.4911C8.28505 13.2768 8.222 12.947 8.22365 12.6003C8.22566 12.1775 8.32219 11.6251 8.71896 11.1201C9.10542 10.6283 9.63893 10.3576 10.1673 10.2075C10.6894 10.0592 11.3034 10 12 10H12.0121ZM8.42908 14.0099L8.42896 14.0049C8.42913 14.0084 8.42912 14.01 8.42908 14.0099ZM12 11.5C13.6607 11.5134 15 10.25 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C10.1907 15 10.0114 14.1705 9.8274 13.3191C9.6334 12.4217 9.43417 11.5 12 11.5ZM9 5C9 5.55228 8.55228 6 8 6C7.44772 6 7 5.55228 7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5ZM11 7.75C11.5523 7.75 12 7.30228 12 6.75C12 6.19772 11.5523 5.75 11 5.75C10.4477 5.75 10 6.19772 10 6.75C10 7.30228 10.4477 7.75 11 7.75ZM6.25 6.75C6.25 7.30228 5.80228 7.75 5.25 7.75C4.69772 7.75 4.25 7.30228 4.25 6.75C4.25 6.19772 4.69772 5.75 5.25 5.75C5.80228 5.75 6.25 6.19772 6.25 6.75ZM5.75 11C6.30228 11 6.75 10.5523 6.75 10C6.75 9.44771 6.30228 9 5.75 9C5.19772 9 4.75 9.44771 4.75 10C4.75 10.5523 5.19772 11 5.75 11Z"
        fill="#F3EA62"
      />
    </svg>
  );
};

export const TrimExtendIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 1.25L7.25 14.75C7.25 15.1642 7.58579 15.5 8 15.5C8.41421 15.5 8.75 15.1642 8.75 14.75L8.75 1.25C8.75 0.835786 8.41421 0.5 8 0.5C7.58579 0.5 7.25 0.835786 7.25 1.25ZM2.5 2H6V3.5H2.5C1.94772 3.5 1.5 3.94772 1.5 4.5V6.25C1.5 6.80228 1.94772 7.25 2.5 7.25L5.5 7.25H6V8.75H5.5C4.94772 8.75 4.5 9.19772 4.5 9.75V11.5C4.5 12.0523 4.94772 12.5 5.5 12.5H6V14H5.5C4.11929 14 3 12.8807 3 11.5V9.75C3 9.39445 3.07422 9.05623 3.20802 8.75H2.5C1.11929 8.75 0 7.63071 0 6.25V4.5C0 3.11929 1.11929 2 2.5 2ZM10.5 7.25H10V8.75H10.5H13.5C14.0523 8.75 14.5 9.19772 14.5 9.75V11.5C14.5 12.0523 14.0523 12.5 13.5 12.5H10V14H13.5C14.8807 14 16 12.8807 16 11.5V9.75C16 8.36929 14.8807 7.25 13.5 7.25H12.792C12.9258 6.94377 13 6.60555 13 6.25V4.5C13 3.11929 11.8807 2 10.5 2H10V3.5H10.5C11.0523 3.5 11.5 3.94772 11.5 4.5V6.25C11.5 6.80228 11.0523 7.25 10.5 7.25Z"
        fill="#8FD460"
      />
    </svg>
  );
};

export const InteractiveIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16077 13.1343L6.5 9.5L2.86575 8.83923C1.78533 8.64279 1 7.70179 1 6.60367C1 5.64223 1.60511 4.78485 2.511 4.46276L11.8688 1.13553C12.1211 1.04584 12.3868 1 12.6546 1C13.9499 1 15 2.05009 15 3.34544C15 3.61317 14.9542 3.87892 14.8645 4.13118L11.5372 13.489C11.2152 14.3949 10.3578 15 9.39633 15C8.29821 15 7.35721 14.2147 7.16077 13.1343ZM10.1239 12.9865L13.4511 3.62867C13.4835 3.53774 13.5 3.44195 13.5 3.34544C13.5 2.87852 13.1215 2.5 12.6546 2.5C12.5581 2.5 12.4623 2.51652 12.3713 2.54885L3.01351 5.87608C2.70565 5.98554 2.5 6.27692 2.5 6.60367C2.5 6.97686 2.76689 7.29666 3.13408 7.36342L6.76833 8.0242L7.79004 8.20996L7.9758 9.23167L8.63658 12.8659C8.70334 13.2331 9.02313 13.5 9.39633 13.5C9.72308 13.5 10.0145 13.2944 10.1239 12.9865Z"
        fill="#AB7AE0"
      />
    </svg>
  );
};

export const UtilsIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6990_1244)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 2.07492L10.1934 6.00003L5.80656 6.00003L8 2.07492ZM6.90882 0.952663C7.38585 0.0990321 8.61415 0.0990302 9.09118 0.952661L11.7107 5.64025C12.1763 6.47346 11.574 7.50003 10.6195 7.50003L5.38047 7.50003C4.42598 7.50003 3.82367 6.47346 4.28929 5.64025L6.90882 0.952663ZM4 15.25C3.47669 15.25 2.9802 15.1352 2.53436 14.9293C1.33339 14.3747 0.5 13.1597 0.5 11.75C0.5 9.81703 2.067 8.25003 4 8.25003C5.933 8.25003 7.5 9.81703 7.5 11.75C7.5 12.2733 7.38515 12.7698 7.17928 13.2157C6.62472 14.4166 5.40968 15.25 4 15.25ZM6 11.75C6 12.8546 5.10457 13.75 4 13.75C2.89543 13.75 2 12.8546 2 11.75C2 10.6455 2.89543 9.75003 4 9.75003C5.10457 9.75003 6 10.6455 6 11.75ZM14 13.5H10.5V10H14V13.5ZM9 9.75003C9 9.05967 9.55964 8.50003 10.25 8.50003H14.25C14.9404 8.50003 15.5 9.05967 15.5 9.75003V13.75C15.5 14.4404 14.9404 15 14.25 15H10.25C9.55964 15 9 14.4404 9 13.75V9.75003Z"
          fill="#8FD460"
        />
      </g>
      <defs>
        <clipPath id="clip0_6990_1244">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AdvancedIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8355 6L8.59551 3.97331L9.3355 2H5.5C5.20741 2 4.94429 2.17814 4.83563 2.4498L2.51266 8.25722C2.5043 8.27813 2.5 8.30045 2.5 8.32297C2.5 8.42074 2.57926 8.5 2.67703 8.5H5.5H7.64155L6.90969 10.5126L5.82791 13.4875C5.73732 13.7366 5.9218 14 6.18686 14C6.29218 14 6.39282 13.9565 6.465 13.8798L13.4212 6.48891C13.4718 6.4351 13.5 6.36399 13.5 6.29009C13.5 6.12988 13.3701 6 13.2099 6H10H7.8355ZM9.39326 1.84597L9.39321 1.8461L9.39326 1.84597ZM10.5625 3L10.7978 2.37266C11.1375 1.46656 10.4677 0.5 9.5 0.5H5.5C4.59405 0.5 3.77937 1.05156 3.44291 1.89271L1.11995 7.70013C1.04071 7.89822 1 8.10962 1 8.32297C1 9.24917 1.75083 10 2.67703 10H3.9039H5.5L4.95455 11.5L4.41822 12.9749C3.9719 14.2023 4.88085 15.5 6.18686 15.5C6.70577 15.5 7.20165 15.2857 7.5573 14.9079L14.5135 7.51696C14.826 7.1849 15 6.74609 15 6.29009C15 5.30145 14.1985 4.5 13.2099 4.5H11.602H10L10.5625 3Z"
        fill="#58D1C9"
      />
    </svg>
  );
};

export const SidebarPanelLeftIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9051_44)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 12.5H2.5C2.22386 12.5 2 12.2761 2 12V4C2 3.72386 2.22386 3.5 2.5 3.5H3C3.27614 3.5 3.5 3.72386 3.5 4V12C3.5 12.2761 3.27614 12.5 3 12.5ZM2.5 14H3C4.10457 14 5 13.1046 5 12V4C5 2.89543 4.10457 2 3 2H2.5C1.39543 2 0.5 2.89543 0.5 4V12C0.5 13.1046 1.39543 14 2.5 14ZM13 12.5H8.5C7.94772 12.5 7.5 12.0523 7.5 11.5V4.5C7.5 3.94772 7.94772 3.5 8.5 3.5H13C13.5523 3.5 14 3.94772 14 4.5V11.5C14 12.0523 13.5523 12.5 13 12.5ZM8.5 14H13C14.3807 14 15.5 12.8807 15.5 11.5V4.5C15.5 3.11929 14.3807 2 13 2H8.5C7.11929 2 6 3.11929 6 4.5V11.5C6 12.8807 7.11929 14 8.5 14Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9051_44">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SidebarPanelRightIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9051_50)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 12.5H7.5C8.05228 12.5 8.5 12.0523 8.5 11.5V4.5C8.5 3.94772 8.05228 3.5 7.5 3.5H3C2.44772 3.5 2 3.94772 2 4.5V11.5C2 12.0523 2.44772 12.5 3 12.5ZM7.5 14H3C1.61929 14 0.5 12.8807 0.5 11.5V4.5C0.5 3.11929 1.61929 2 3 2H7.5C8.88071 2 10 3.11929 10 4.5V11.5C10 12.8807 8.88071 14 7.5 14ZM13 12.5H13.5C13.7761 12.5 14 12.2761 14 12V4C14 3.72386 13.7761 3.5 13.5 3.5H13C12.7239 3.5 12.5 3.72386 12.5 4V12C12.5 12.2761 12.7239 12.5 13 12.5ZM13.5 14H13C11.8954 14 11 13.1046 11 12V4C11 2.89543 11.8954 2 13 2H13.5C14.6046 2 15.5 2.89543 15.5 4V12C15.5 13.1046 14.6046 14 13.5 14Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9051_50">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddPlusIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.75C8.41421 1.75 8.75 2.08579 8.75 2.5V7.25H13.5C13.9142 7.25 14.25 7.58579 14.25 8C14.25 8.41421 13.9142 8.75 13.5 8.75H8.75V13.5C8.75 13.9142 8.41421 14.25 8 14.25C7.58579 14.25 7.25 13.9142 7.25 13.5V8.75H2.5C2.08579 8.75 1.75 8.41421 1.75 8C1.75 7.58579 2.08579 7.25 2.5 7.25H7.25V2.5C7.25 2.08579 7.58579 1.75 8 1.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

// Layer type icons for LayersTreeView - all use consistent gray color
const LAYER_ICON_COLOR = "#888";

export const ShapeLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 3H4.5C3.67157 3 3 3.67157 3 4.5V11.5C3 12.3284 3.67157 13 4.5 13H11.5C12.3284 13 13 12.3284 13 11.5V4.5C13 3.67157 12.3284 3 11.5 3ZM4.5 1.5C2.84315 1.5 1.5 2.84315 1.5 4.5V11.5C1.5 13.1569 2.84315 14.5 4.5 14.5H11.5C13.1569 14.5 14.5 13.1569 14.5 11.5V4.5C14.5 2.84315 13.1569 1.5 11.5 1.5H4.5Z"
      fill={LAYER_ICON_COLOR}
    />
  </svg>
);

export const AudioLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3V13"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5 5V11"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11 5V11"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2 7V9"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14 7V9"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const NullLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 3C3.67157 3 3 3.67157 3 4.5V6.25C3 6.66421 2.66421 7 2.25 7C1.83579 7 1.5 6.66421 1.5 6.25V4.5C1.5 2.84315 2.84315 1.5 4.5 1.5H6.25C6.66421 1.5 7 1.83579 7 2.25C7 2.66421 6.66421 3 6.25 3H4.5ZM9 2.25C9 1.83579 9.33579 1.5 9.75 1.5H11.5C13.1569 1.5 14.5 2.84315 14.5 4.5V6.25C14.5 6.66421 14.1642 7 13.75 7C13.3358 7 13 6.66421 13 6.25V4.5C13 3.67157 12.3284 3 11.5 3H9.75C9.33579 3 9 2.66421 9 2.25ZM2.25 9C2.66421 9 3 9.33579 3 9.75V11.5C3 12.3284 3.67157 13 4.5 13H6.25C6.66421 13 7 13.3358 7 13.75C7 14.1642 6.66421 14.5 6.25 14.5H4.5C2.84315 14.5 1.5 13.1569 1.5 11.5V9.75C1.5 9.33579 1.83579 9 2.25 9ZM13.75 9C14.1642 9 14.5 9.33579 14.5 9.75V11.5C14.5 13.1569 13.1569 14.5 11.5 14.5H9.75C9.33579 14.5 9 14.1642 9 13.75C9 13.3358 9.33579 13 9.75 13H11.5C12.3284 13 13 12.3284 13 11.5V9.75C13 9.33579 13.3358 9 13.75 9Z"
      fill={LAYER_ICON_COLOR}
    />
  </svg>
);

export const CameraLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5.5C2 4.67157 2.67157 4 3.5 4H5L6 2.5H10L11 4H12.5C13.3284 4 14 4.67157 14 5.5V12C14 12.8284 13.3284 13.5 12.5 13.5H3.5C2.67157 13.5 2 12.8284 2 12V5.5Z"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
    />
    <circle
      cx="8"
      cy="8.5"
      r="2.5"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
    />
  </svg>
);

export const LightLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1V2M8 14V15M1 8H2M14 8H15M3.05 3.05L3.76 3.76M12.24 12.24L12.95 12.95M3.05 12.95L3.76 12.24M12.24 3.76L12.95 3.05"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="8" cy="8" r="3" stroke={LAYER_ICON_COLOR} strokeWidth="1.5" />
  </svg>
);

export const AdjustmentLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 2V6M4 10V14M8 2V8M8 12V14M12 2V4M12 8V14"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="4" cy="8" r="2" stroke={LAYER_ICON_COLOR} strokeWidth="1.5" />
    <circle cx="8" cy="10" r="2" stroke={LAYER_ICON_COLOR} strokeWidth="1.5" />
    <circle cx="12" cy="6" r="2" stroke={LAYER_ICON_COLOR} strokeWidth="1.5" />
  </svg>
);

export const DataLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="8"
      cy="4"
      rx="5"
      ry="2"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
    />
    <path
      d="M3 4V8C3 9.10457 5.23858 10 8 10C10.7614 10 13 9.10457 13 8V4"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
    />
    <path
      d="M3 8V12C3 13.1046 5.23858 14 8 14C10.7614 14 13 13.1046 13 12V8"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
    />
  </svg>
);

export const GuideLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2V14M2 8H14"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="8" cy="8" r="3" stroke={LAYER_ICON_COLOR} strokeWidth="1.5" />
  </svg>
);

export const DefaultLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="2"
      width="12"
      height="12"
      rx="2"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
    />
  </svg>
);

export const TextLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 13H10.5"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 4.5V3H13.5V4.5"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 3V13"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ImageLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 3H4.50005C3.67162 3 3.00005 3.67157 3.00005 4.5V9.52717L3.96161 8.82786C4.58293 8.37599 5.4263 8.38219 6.04091 8.84314L6.96874 9.53902L9.33653 7.50948C10.0105 6.93181 11.0102 6.95021 11.6624 7.55228L13 8.78701V4.5C13 3.67157 12.3285 3 11.5 3ZM14.5 10.4978V4.5C14.5 2.84315 13.1569 1.5 11.5 1.5H4.50005C2.8432 1.5 1.50005 2.84315 1.50005 4.5V10.9917C1.49998 10.9976 1.49998 11.0036 1.50005 11.0095V11.5C1.50005 13.1569 2.8432 14.5 4.50005 14.5H11.5C13.1569 14.5 14.5 13.1569 14.5 11.5V10.5026V10.4978ZM13 10.8284L10.645 8.65448C10.5518 8.56847 10.409 8.56584 10.3127 8.64837L7.48814 11.0694L7.03135 11.461L6.55005 11.1L5.14091 10.0431C5.05311 9.97729 4.93262 9.97641 4.84386 10.041L3.00005 11.3819V11.5C3.00005 12.3284 3.67162 13 4.50005 13H11.5C12.3285 13 13 12.3284 13 11.5V10.8284ZM7.50004 6C7.50004 6.82843 6.82847 7.5 6.00005 7.5C5.17162 7.5 4.50005 6.82843 4.50005 6C4.50005 5.17157 5.17162 4.5 6.00005 4.5C6.82847 4.5 7.50004 5.17157 7.50004 6Z"
      fill={LAYER_ICON_COLOR}
    />
  </svg>
);

export const VideoLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="3"
      width="10"
      height="10"
      rx="2"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
    />
    <path
      d="M11 7L15 5V11L11 9"
      stroke={LAYER_ICON_COLOR}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SolidLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="2" width="12" height="12" rx="2" fill={LAYER_ICON_COLOR} />
  </svg>
);

export const PrecompLayerIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 3.5H12C12.8284 3.5 13.5 4.17157 13.5 5V5.5H11.5V3.5ZM11.5 7V9H13.5V7H11.5ZM15 7V9V10.5V11C15 12.6569 13.6569 14 12 14H11.5H10H6H4.5H4C2.34315 14 1 12.6569 1 11V10.5V9V7V5.5V5C1 3.34315 2.34315 2 4 2H4.5H6H10H11.5H12C13.6569 2 15 3.34315 15 5V5.5V7ZM13.5 10.5H11.5V12.5H12C12.8284 12.5 13.5 11.8284 13.5 11V10.5ZM10 3.5H6V12.5H10V3.5ZM4.5 12.5V10.5H2.5V11C2.5 11.8284 3.17157 12.5 4 12.5H4.5ZM4.5 7V9H2.5V7H4.5ZM4.5 5.5H2.5V5C2.5 4.17157 3.17157 3.5 4 3.5H4.5V5.5Z"
      fill={LAYER_ICON_COLOR}
    />
  </svg>
);

/**
 * LayerTypeIcon - renders an icon based on the layer type
 * All icons use consistent gray color for uniformity.
 * Layer types from @blings/blings-player LayerTypes enum:
 * 0=precomp, 1=solid, 2=still, 3=nullLayer, 4=shape, 5=text, 6=audio,
 * 7=pholderVideo, 8=imageSeq, 9=video, 10=pholderStill, 11=guide,
 * 12=adjustment, 13=camera, 14=light, 15=data
 */
export const LayerTypeIcon = ({
  layerType,
  size = 16,
}: {
  layerType?: number;
  size?: number;
}) => {
  switch (layerType) {
    case 0: // precomp
      return <PrecompLayerIcon size={size} />;
    case 1: // solid
      return <SolidLayerIcon size={size} />;
    case 2: // still
    case 10: // pholderStill
      return <ImageLayerIcon size={size} />;
    case 3: // nullLayer
      return <NullLayerIcon size={size} />;
    case 4: // shape
      return <ShapeLayerIcon size={size} />;
    case 5: // text
      return <TextLayerIcon size={size} />;
    case 6: // audio
      return <AudioLayerIcon size={size} />;
    case 7: // pholderVideo
    case 9: // video
      return <VideoLayerIcon size={size} />;
    case 8: // imageSeq
      return <ImageLayerIcon size={size} />;
    case 11: // guide
      return <GuideLayerIcon size={size} />;
    case 12: // adjustment
      return <AdjustmentLayerIcon size={size} />;
    case 13: // camera
      return <CameraLayerIcon size={size} />;
    case 14: // light
      return <LightLayerIcon size={size} />;
    case 15: // data
      return <DataLayerIcon size={size} />;
    default:
      return <DefaultLayerIcon size={size} />;
  }
};
